<template>
    <transition name="fade">
        <v-container bg fill-height grid-list-md text-xs-center
                        style="width: 100%"
                        v-show="preloading"
                        :class="{'preloading' : true, 'long-form-preloader' : step == 4}"
        >
            <div class="preloader-circle-block">
                <div class="preloader-circle"></div>
            </div>

            <v-layout row wrap align-center class="preloading-container">
                <v-carousel
                    :show-arrows="false"
                    :cycle="preloading"
                    :interval="interval"
                    :key="step"
                    v-show="preloading"
                    height="auto"
                    class="preloader-carousel-slider"
                >
                    <v-carousel-item xs12 sm8 md6 lg3 xl2 class="main-carousel-slider-item" v-if="step<2">
                        <v-flex d-flex class="main-carousel-slider-item-content">
                            <div class="main-carousel-slider-icons">
                                <img src="/png/car.png"/>
                                <img src="/png/gaz.png"/>
                            </div>
                            <div class="main-carousel-slider-text">
                                Заполняем за Вас все данные по автомобилю. Проверьте их обязательно.
                            </div>
                        </v-flex>
                    </v-carousel-item>
                    <v-carousel-item xs12 sm8 md6 lg3 xl2 class="main-carousel-slider-item" v-if="step<2">
                        <v-flex d-flex class="main-carousel-slider-item-content">
                            <div class="main-carousel-slider-icons">
                                <img src="/png/man-search.png"/>
                            </div>
                            <div class="main-carousel-slider-text">
                                Мы найдем Ваш текущий страховой полис. Чтобы не было перерыва в сроках, поставим дату начала на следующий день после его окончания.
                            </div>
                        </v-flex>
                    </v-carousel-item>
                    <v-carousel-item xs12 sm8 md6 lg3 xl2 class="main-carousel-slider-item" v-if="step<2">
                        <v-flex d-flex class="main-carousel-slider-item-content">
                            <div class="main-carousel-slider-icons">
                                <img src="/svg/alarm-clock_2.svg"/>
                            </div>
                            <div class="main-carousel-slider-text">
                                Укажите Ваш телефон и почту и Вы  больше не забудете купить ОСАГО вовремя. Мы заранее напомним, когда у Вас заканчивается полис.
                            </div>
                        </v-flex>
                    </v-carousel-item>

                    <v-carousel-item xs12 sm8 md6 lg3 xl2 class="main-carousel-slider-item" v-if="step===2">
                        <v-flex d-flex class="main-carousel-slider-item-content">
                            <div class="main-carousel-slider-icons">
                                <img src="/png/target.png"/>
                            </div>
                            <div class="main-carousel-slider-text">
                                Теперь корректно введите данные по водителям. Вам понадобятся права.
                            </div>
                        </v-flex>
                    </v-carousel-item>
                    <v-carousel-item xs12 sm8 md6 lg3 xl2 class="main-carousel-slider-item" v-if="step===2">
                        <v-flex d-flex class="main-carousel-slider-item-content">
                            <div class="main-carousel-slider-icons">
                                <img src="/png/hand-with-pen.png"/>
                            </div>
                            <div class="main-carousel-slider-text">
                                По закону рассчитать примерную цену ОСАГО невозможно. Чтобы получить окончательный расчет обязательно впишите всех водителей.
                            </div>
                        </v-flex>
                    </v-carousel-item>
                    <v-carousel-item xs12 sm8 md6 lg3 xl2 class="main-carousel-slider-item" v-if="step===2">
                        <v-flex d-flex class="main-carousel-slider-item-content">
                            <div class="main-carousel-slider-icons">
                                <img src="/png/search.png"/>
                            </div>
                            <div class="main-carousel-slider-text">
                                Проверьте все ли верно внесено. От этого зависит скидка за безаварийную езду. Она может быть до 50%.
                            </div>
                        </v-flex>
                    </v-carousel-item>


                    <v-carousel-item xs12 sm8 md6 lg3 xl2 class="main-carousel-slider-item" v-if="step===3">
                        <v-flex d-flex class="main-carousel-slider-item-content">
                            <div class="main-carousel-slider-icons">
                                <img src="/png/100.png"/>
                            </div>
                            <div class="main-carousel-slider-text">
                                Цены у нас на сайте не отличаются от цен в страховых компаниях. Мы покажем Вам сразу все возможные предложения.
                            </div>
                        </v-flex>
                    </v-carousel-item>
                    <v-carousel-item xs12 sm8 md6 lg3 xl2 class="main-carousel-slider-item" v-if="step===3">
                        <v-flex d-flex class="main-carousel-slider-item-content">
                            <div class="main-carousel-slider-icons">
                                <img src="/png/ok.png"/>
                            </div>
                            <div class="main-carousel-slider-text">
                                Мы показываем только окончательные цены. Никаких перерасчетов, уточнений и корректировок.
                            </div>
                        </v-flex>
                    </v-carousel-item>
                    <v-carousel-item xs12 sm8 md6 lg3 xl2 class="main-carousel-slider-item" v-if="step===3">
                        <v-flex d-flex class="main-carousel-slider-item-content">
                            <div class="main-carousel-slider-icons">
                                <img src="/png/passport.png"/>
                            </div>
                            <div class="main-carousel-slider-text">
                                Заполните всего 3 поля о собственнике. Вам понадобится паспорт владельца автомобиля.
                            </div>
                        </v-flex>
                    </v-carousel-item>


                    <v-carousel-item xs12 sm8 md6 lg3 xl2 class="main-carousel-slider-item" v-if="step===4">
                        <v-flex d-flex class="main-carousel-slider-item-content">
                            <div class="main-carousel-slider-icons">
                                <img src="/png/telescope.png"/>
                            </div>
                            <div class="main-carousel-slider-text">
                                Мы найдем и заполним данные СТС (ПТС). Проверьте их внимательно.
                            </div>
                        </v-flex>
                    </v-carousel-item>
                    <v-carousel-item xs12 sm8 md6 lg3 xl2 class="main-carousel-slider-item" v-if="step===4">
                        <v-flex d-flex class="main-carousel-slider-item-content">
                            <div class="main-carousel-slider-icons">
                                <img src="/png/exclamation_mark.png"/>
                            </div>
                            <div class="main-carousel-slider-text">
                                Если Вы нашли ошибку или данные не подгрузились, исправьте их или заполните сами.
                            </div>
                        </v-flex>
                    </v-carousel-item>
                    <v-carousel-item xs12 sm8 md6 lg3 xl2 class="main-carousel-slider-item" v-if="step===4">
                        <v-flex d-flex class="main-carousel-slider-item-content">
                            <div class="main-carousel-slider-icons">
                                <img src="/png/abacus.png"/>
                            </div>
                            <div class="main-carousel-slider-text">
                                Если сведения указаны верно, то нажмите кнопку рассчитать и узнайте точную цену полиса. Больше заполнять ничего не придется.
                            </div>
                        </v-flex>
                    </v-carousel-item>

                     <v-carousel-item xs12 sm8 md6 lg3 xl2 class="main-carousel-slider-item" v-if="resultPreloading || step == 5">
                        <v-flex d-flex class="main-carousel-slider-item-content">
                            <div class="main-carousel-slider-icons">
                                <img src="/png/stareyes.png"/>
                            </div>
                            <div class="main-carousel-slider-text">
                                Если Вас устроила цена не затягивайте с покупкой. Страховые компании меняют стоимость полиса без предупреждения.  Успейте купить сейчас по выгодной цене.
                            </div>
                        </v-flex>
                    </v-carousel-item>
                    <v-carousel-item xs12 sm8 md6 lg3 xl2 class="main-carousel-slider-item" v-if="resultPreloading || step == 5">
                        <v-flex d-flex class="main-carousel-slider-item-content">
                            <div class="main-carousel-slider-icons">
                                <img src="/png/man-with-hand.png"/>
                            </div>
                            <div class="main-carousel-slider-text">
                                Вы покупаете полис на сайте той компании которую выберете. Мы не принимаем от Вас деньги, а только сравниваем цены.  Для оплаты нажмите купить и перейдите на сайт страховой компании.
                            </div>
                        </v-flex>
                    </v-carousel-item>
                    <v-carousel-item xs12 sm8 md6 lg3 xl2 class="main-carousel-slider-item" v-if="resultPreloading || step == 5">
                        <v-flex d-flex class="main-carousel-slider-item-content">
                            <div class="main-carousel-slider-icons">
                                <img src="/png/letter.png"/>
                            </div>
                            <div class="main-carousel-slider-text">
                                После оплаты полис будет у Вас на почте через 10 минут. Он сразу попадает в РСА и ГИБДД. Можете скачать его у нас в личном кабинете.
                            </div>
                        </v-flex>
                    </v-carousel-item>

                </v-carousel>
                <v-flex class="skip-block" v-if="allowSkipButton">
                    <a @click="skipLoading">
                        Пропустить заставку
                    </a>
                </v-flex>
            </v-layout>
        </v-container>
    </transition>
</template>
<script>
export default {
    name: "Preloading",
    props: ['preloading', 'step', 'resultPreloading', 'slideInterval'],
    data: () => ({
        interval: 4000,
        allowSkipButton: false,
        preloaderStepFlags: {
            0 : false,
            1 : false,
            2 : false,
            3 : false,
            4 : false,
            5 : false
        }
    }),

    methods: {
        skipLoading() {
            this.$emit('stopPreloading')
        }
    },
    watch: {
        preloading: function(val) {
            if (this.step == 5) {
                this.interval = 9000
            }
            if (val) {
                this.allowSkipButton = !!this.preloaderStepFlags[this.step];
                this.preloaderStepFlags[this.step] = true
            }
        }
    },
    created: function() {
        if (this.slideInterval) {
            this.interval = this.slideInterval
        }
        if (this.step == 5) {
            this.interval = 9000
        }
        if (sessionStorage.getItem('stepFlags') !== null) {
            const stepFlags = JSON.parse(sessionStorage.getItem('stepFlags'))
            this.preloaderStepFlags = stepFlags
            if ((stepFlags[this.step]) && this.step) {
                this.allowSkipButton = true
            }
        }
    }
}
</script>
<style scoped>

    .preloading {
        position: fixed;
        z-index: 999;
        height: 100%;
        width: 100%;
        max-width: 100%;
        overflow: visible;
        margin: auto;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        background: white;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }

    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
    {
        opacity: 0;
    }

    .preloader-circle-block{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: fit-content;
        height: fit-content;
        text-align: center;
        z-index: 5;
    }

    .preloader-circle {
        background: #00ba57;
        max-width: 624px;
        max-height: 624px;
        width: 100vw;
        height: 100vw;
        margin: auto;
        border-radius: 100%;
        animation: grow 2s infinite;
        -webkit-animation: grow 2s infinite;
    }

    .skip-block{
        position: absolute;
        bottom: 10px;
        right: 50%;
        transform: translate(50%, 0);
        z-index: 100;
        text-decoration: underline;
        width: fit-content;
    }
    @media screen and (min-width: 1600px){
        .skip-block{
            bottom: 50px;
        }
    }

    @-webkit-keyframes grow {
        0% {
            -webkit-transform: scale(0.7)
        }

        50% {
            -webkit-transform: scale(1)
        }

        100% {
            -webkit-transform: scale(0.7)
        }
    }

    .preloading-container{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        z-index: 10;
    }

    @media screen and (max-width: 600px){
        @-webkit-keyframes grow {
            0% {
                -webkit-transform: scale(0.8)
            }

            50% {
                -webkit-transform: scale(1)
            }

            100% {
                -webkit-transform: scale(0.8)
            }
        }
    }

</style>
<style>
    .preloader-carousel-slider{
        position: relative;
    }
    .preloader-carousel-slider .main-carousel-slider-item-content {
        flex-direction: column;

    }
    .preloader-carousel-slider .main-carousel-slider-icons{
        display: flex;
        justify-content: center;
    }
    .preloader-carousel-slider .v-carousel{
        box-shadow: none;
        margin: 0 auto;
    }
    .preloader-carousel-slider  .v-carousel__controls{
        position: relative;
        padding: 35px;
        background: none;
    }
    .preloader-carousel-slider img{
        max-height: 50px;
    }
    .preloader-carousel-slider .main-carousel-slider-icons img{
        margin: 0 8px;
    }
    .preloader-carousel-slider .main-carousel-slider-text{
        color: #fff;
        text-shadow: none;
        line-height: 23px;
        text-align: center;
        padding-top: 27px;
        max-width: 50%;
        margin: 0 auto;
        font-weight: bold;
        font-size: 16px;
        min-width: 300px;
    }
    @media (max-width: 600px){
        .preloader-carousel-slider .main-carousel-slider-icons{
            height: 80px;
        }
        .preloader-carousel-slider .main-carousel-slider-icons img{
            max-height: 80px;
            width: auto;
        }
    }
    .preloader-carousel-slider .v-btn .v-btn__content .v-icon{
        color: #fff;
    }
    .preloader-carousel-slider .v-btn.v-btn--active .v-btn__content .v-icon{
        color: #126F3D;
    }
    .preloader-carousel-slider .v-btn:hover .v-icon{
        -webkit-text-stroke: 1px #126F3D;
        text-shadow: 0px 5px 6px rgba(12, 111, 61 , 0.4);
    }
    .preloader-carousel-slider .v-btn .v-btn__content .v-icon{
        font-size: 15px;
        color: #FFFFFF;
        opacity: 1;
    }
    .preloader-carousel-slider .v-carousel__prev, .preloader-carousel-slider .v-carousel__next{
        display: none;
    }
    .preloader-carousel-slider .v-btn:before{
        display: none;
    }
    .preloader-carousel-slider .v-btn.v-btn--active .v-btn__content .v-icon{
        -webkit-text-stroke: 1px #126F3D;
        text-shadow: 0px 5px 6px rgba(12, 111, 61 , 0.4);
    }
    .preloader-carousel-slider .v-carousel__controls{
        position: relative;
        padding: 35px;
        background: none;
    }
    .preloader-carousel-slider.v-carousel{
        box-shadow: none;
    }
    .preloader-carousel-slider .v-window__container{
        height: fit-content !important;
    }

    .preloader-carousel-slider .v-carousel__item{
        height: fit-content !important;
    }

    @media screen and (min-width: 1600px){
        .preloader-carousel-slider .main-carousel-slider-text{
            max-width: 40%;
        }
    }
    @media screen and (max-width: 600px){
        .preloader-carousel-slider .main-carousel-slider-text{
            min-width: 250px;
        }
    }

    @media(max-width: 600px){
        .long-form-preloader .preloader-carousel-slider .main-carousel-slider-text{
            padding-top: 15px;
        }
        .long-form-preloader .preloader-carousel-slider .main-carousel-slider-icons {
            height: 60px;
        }
        .long-form-preloader .preloader-carousel-slider .main-carousel-slider-icons img {
            max-height: 60px;
        }
        .long-form-preloader .v-btn--icon.v-btn--small {
            width: 20px;
        }
        .long-form-preloader .preloader-carousel-slider .main-carousel-slider-text{
            font-size: 14px;
            line-height: 19px;
        }
        .long-form-preloader .preloader-carousel-slider .v-carousel__controls{
            padding: 15px;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/elements/Preloader.vue